<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: 'Audit',
};
</script>



// WEBPACK FOOTER //
// src/view/Audit/Audit.vue